import { useQuery } from '@tanstack/react-query';
import { useCan } from '@/modules/tenant/hooks/useTenantAuth';
import { aiApi } from '../services/aiApi';

export function useAIBudgetCheck() {
  // ACL-09 (#611, D-29) — the budget read only matters before a paid AI action,
  // so it is skipped for an employee without inventory.ai.generate.
  const canGenerate = useCan('inventory.ai.generate');

  return useQuery({
    queryKey: ['ai', 'usage', 'check'],
    queryFn: () => aiApi.checkBudget(),
    staleTime: 1000 * 30, // Refresh every 30s
    enabled: canGenerate,
  });
}
